import React from 'react';

const Processing = () => (
  <div className="c-handoff-bar c-handoff-bar_processing">
    <div className="c-handoff-bar__spinner">
      <svg viewBox="25 25 50 50">
        <circle
          cx="50"
          cy="50"
          r="20"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="8"
        />
      </svg>
    </div>
    <span className="u-fontsize-tiny u-type--bold u-co-white u-ml-">
      Handing off…
    </span>
  </div>
);

export default Processing;
